import type { Option } from '@magicdoorinc/ui';
import type { HydratedBankAccountDto } from '~/swagger/portal/Api';

export interface BankAccountOption extends Option {
  account: HydratedBankAccountDto;
}

export const buildBankAccountOptions = (
  accounts: HydratedBankAccountDto[] | undefined,
  filter?: (account: HydratedBankAccountDto) => boolean
): BankAccountOption[] => {
  if (!accounts) {
    return [];
  }

  return accounts
    .filter((account) => (filter ? filter(account) : true))
    .map((account) => ({
      label: account.name,
      value: account.id,
      account,
    }));
};

export const getCompanyAccountIds = (accounts: HydratedBankAccountDto[] | undefined): string[] => {
  if (!accounts) {
    return [];
  }

  return accounts.filter((account) => account.companyAccount === true).map((account) => account.id);
};

export const findBankAccountById = (
  accounts: HydratedBankAccountDto[] | undefined,
  bankAccountId: string | null | undefined
): HydratedBankAccountDto | undefined => {
  if (!accounts || !bankAccountId) {
    return undefined;
  }

  return accounts.find((account) => account.id === bankAccountId);
};
